// @flow

const EnvironmentEnum = {
  Sandbox: 'sandbox',
  Staging: 'staging',
  Demo: 'demo',
  Production: 'production',
};

export default EnvironmentEnum;
